'use strict';

var _ = require('lodash');
var ProfileChartAddFlightModalController = function ProfileChartAddFlightModalController($scope, profileChartAddFlightModalDataService) {
  $scope.legsList = [];
  $scope.flightNumbersList = [];
  $scope.showDatePicker = true;
  $scope.datePicker = {};
  $scope.error = {
    showMessage: false
  };
  $scope.populateDropdowns = function () {
    $scope.showDatePicker = false;
    $scope.leg = undefined;
    $scope.flightNumber = undefined;
    $scope.datePicker.departureDate = undefined;
    $scope.$apply();
    profileChartAddFlightModalDataService.getDropdownData($scope.contextData.screenMode, $scope.contextData.flightSummaryRows).then(function (data) {
      $scope.legsList = data.legsList;
      $scope.flightNumbersList = data.flightNumbersList;
      $scope.datePickerOptions = {
        enabledDates: _.reduce(data.departureDatesList, function (moments, departureDate) {
          moments.push(departureDate.value);
          return moments;
        }, [])
      };
      $scope.datePicker.minDate = _.first(data.departureDatesList);
      $scope.datePicker.maxDate = _.last(data.departureDatesList);
      $scope.showDatePicker = true;
    });
  };
  $scope.addFlight = function () {
    return profileChartAddFlightModalDataService.verifySelection($scope.leg, $scope.flightNumber, $scope.datePicker.departureDate, $scope.contextData.screenMode, $scope.contextData.flightSummaryRows).then(function (entities) {
      var entity = _.find(entities, {
        cabinCode: $scope.contextData.primaryEntity.cabinCode
      });
      if (_.isUndefined(entity)) {
        $scope.error.showMessage = true;
      } else {
        $scope.getReferenceEntity({
          entity: entity
        });
        $scope.hideModal();
      }
    });
  };
  $scope.$watchGroup(['leg', 'flightNumber', 'datePicker.departureDate'], function () {
    $scope.error.showMessage = false;
  });
};
ProfileChartAddFlightModalController.$inject = ['$scope', 'ProfileChartAddFlightModalDataService'];
module.exports = ProfileChartAddFlightModalController;